var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.results),function(company){return _c('div',{key:'company_' + company.id,staticClass:"search_result company_search_result"},[_c('div',{staticClass:"is-flex is-align-items-center is-justify-content-flex-end",attrs:{"dir":"ltr"}},[_c('b',[_vm._v("Company: (ID: "+_vm._s(company.id)+") ")]),_c('link-entity',{attrs:{"payload":company.resource == undefined
            ? company
            : company.resource.company}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }